export const SUPPORT_EMAIL = 'hello@nessoapp.com';
